import SessionIcon from '../../../app/assets/icons/session.svg?react';
import { useThemeContext } from '../../Theme/providers/ThemeContextProvider';
import { useTranslationsContext } from '../../Translations/providers/TranslationsContextProvider';
import { Column } from '../../../app/components/Column/Column';
import { Button } from '../../../app/components/Button/Button';
import { Message } from '../../../app/components/Messages/Message';
import { Modal } from '../../../app/components/Modal/Modal';
import { SheetModal } from '../../../app/components/SheetModal/SheetModal';
import { SheetModalHeader } from '../../../app/components/SheetModal/SheetModalHeader';
import { useIsMobile } from '../../../app/hooks/useIsMobile';

export interface ProfessionalAvailableModalProps {
	onClose: () => void;
	onClick: () => void;
}

export function ProfessionalAvailableModal({
	onClose,
	onClick,
}: Readonly<ProfessionalAvailableModalProps>) {
	const { t } = useTranslationsContext();
	const theme = useThemeContext();
	const isMobile = useIsMobile();

	const content = () => {
		return (
			<Column $spaceBetween $fillHeight $gap={18}>
				<Message message={t('too_early.professional_available')} type={'success'}></Message>
				<Button
					onClick={() => {
						onClick();
					}}
					$color={'primary'}
					$block
				>
					{t('waiting_room.access')}
				</Button>
			</Column>
		);
	};

	return (
		<>
			{isMobile && (
				<SheetModal
					isOpen
					header={
						<SheetModalHeader
							prepend={
								<SessionIcon fill={theme.colors.brand.primary[300]} width={25} height={25} />
							}
							title={t('too_early.title')}
						/>
					}
					onClose={onClose}
				>
					{content()}
				</SheetModal>
			)}
			{!isMobile && (
				<Modal
					show
					onClose={onClose}
					title={t('too_early.title')}
					$fitToChildren
					prepend={
						<SessionIcon
							fill={theme.colors.brand.primary[300]}
							width={25}
							height={25}
						></SessionIcon>
					}
				>
					{content()}
				</Modal>
			)}
		</>
	);
}
